<a
  class="sidebar-item"
  [routerLink]="homeRouterLink"
  routerLinkActive="active"
  tiimeTooltip="Accueil"
  tooltipPosition="right"
  data-cy="home-link"
>
  <img class="tiime-icon" src="assets/tiime.svg" />
</a>
@if ((isAuthenticated$ | async) && (businessUser$ | async)) {
  <a
    class="sidebar-item"
    [routerLink]="companiesRouterLink"
    routerLinkActive="active"
    tiimeTooltip="Dossiers"
    tooltipPosition="right"
    data-cy="companies-link"
  >
    <mat-icon svgIcon="icon-dossier"></mat-icon>
  </a>
  <ng-container *appHasRole>
    <a
      class="sidebar-item"
      [routerLink]="planningRouterLink"
      routerLinkActive="active"
      tiimeTooltip="Planning"
      tooltipPosition="right"
      data-cy="planning-link"
    >
      <mat-icon svgIcon="icon-planning"></mat-icon>
    </a>
    @if (canAccessToTimeTrackings$ | async) {
      <a
        class="sidebar-item"
        [routerLink]="timeTrackingsRouterLink"
        routerLinkActive="active"
        tiimeTooltip="Saisie des temps"
        tooltipPosition="right"
        data-cy="time-trackings-link"
      >
        <mat-icon svgIcon="icon-temps"></mat-icon>
      </a>
    }
    @if (canAccessToOpportunities$ | async) {
      <a
        class="sidebar-item"
        [routerLink]="opportunitiesRouterLink"
        routerLinkActive="active"
        tiimeTooltip="Opportunités"
        tooltipPosition="right"
        data-cy="opportunities-link"
      >
        <mat-icon svgIcon="icon-contrats"></mat-icon>
      </a>
    }
    @if (canAccessToAdministration$ | async) {
      <a
        class="sidebar-item"
        [routerLink]="adminRouterLink"
        routerLinkActive="active"
        tiimeTooltip="Administration"
        tooltipPosition="right"
        data-cy="administration-link"
      >
        <mat-icon svgIcon="icon-admin"></mat-icon>
      </a>
    }
  </ng-container>
  <div class="spacer"></div>
  <a
    class="sidebar-bottom-item"
    tiime-button
    color="primary"
    icon
    [routerLink]="assistantRouterLink"
    routerLinkActive="active"
    tiimeTooltip="Assistant Tiime"
    tooltipPosition="right"
    *appHasRole="['ROLE_EXPERT_ASSISTANT_TESTER']"
  >
    <mat-icon svgIcon="icon-assistant"></mat-icon>
  </a>
  <button
    class="sidebar-bottom-item"
    #notificationOverlayAnchor
    tiime-button
    color="primary"
    icon
    [matBadge]="notificationsCounter$ | async"
    matBadgeSize="small"
    matBadgePosition="after"
    matBadgeColor="warn"
    [matBadgeHidden]="(notificationsCounter$ | async) === 0"
    data-cy="notifications-action"
    (click)="openNotificationsOverlay()"
    tiimeTooltip="Notifications"
    tooltipPosition="right"
  >
    <mat-icon svgIcon="icon-notifications"></mat-icon>
  </button>
  <div class="sidebar-bottom-item" id="beamer-menu-item">
    <button
      tiime-button
      color="primary"
      icon
      data-cy="new-features-action"
      tiimeTooltip="Nouveautés"
      tooltipPosition="right"
    >
      <mat-icon svgIcon="icon-nouveautes"></mat-icon>
    </button>
  </div>
  <button
    class="sidebar-bottom-item"
    tiime-button
    color="primary"
    icon
    data-cy="help-action"
    tiimeTooltip="Assistance"
    tooltipPosition="right"
    [matMenuTriggerFor]="helpMenu"
  >
    <mat-icon svgIcon="icon-help"></mat-icon>
  </button>
  <mat-menu #helpMenu="matMenu" yPosition="above" xPosition="after">
    <button mat-menu-item data-cy="help-menu" (click)="toggleHelpScoutBeacon()">
      <mat-icon>help</mat-icon>
      <span>Aide</span>
    </button>
    <a mat-menu-item data-cy="formation-menu" href="https://www.tiime.fr/ec/formations" target="_blank" rel="noopener">
      <mat-icon>school</mat-icon>
      <span>Formations</span>
    </a>
    <button mat-menu-item data-cy="support-menu" (click)="openContactSupportDialog()">
      <mat-icon>support_agent</mat-icon>
      <span>Contacter le support</span>
    </button>
    <button mat-menu-item data-cy="keyboard-menu" (click)="openKeyboardShortcutsDialog()">
      <mat-icon>keyboard</mat-icon>
      <span>Raccourcis clavier</span>
    </button>
  </mat-menu>
  <app-business-user-account-menu class="sidebar-bottom-item" tooltipPosition="right"></app-business-user-account-menu>
}
